import * as XLSX from 'xlsx';

export function downloadTemplate(
  rows: Record<string, string>[],
  filename: string,
): void {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, filename);
}
